import { formatFixingTimeAtDateOnly, type DateOnly, type FixingIndex } from '@talos/kyoko';

export function FixingTime({ fixingIndex, fixingDate }: { fixingIndex: FixingIndex; fixingDate: DateOnly }) {
  return <>{formatFixingTimeAtDateOnly(fixingIndex, fixingDate)}</>;
}
